import { schemes, zSchema } from "../../schema-validation";
import { WalletTransactionType } from "../../wallets";

export const walletTransactionWebhookSchema = zSchema.object({
  companyID: schemes.companyID(),
  employeeID: schemes.mongoObjectId().nullable(),
  contractorID: schemes.mongoObjectId().nullable(),
  gross_amount: zSchema.number(),
  last_four: zSchema.string().nullable(),
  net_amount: zSchema.number(),
  partner_fee: zSchema.number(),
  test: zSchema.boolean(),
  timestamp: zSchema.string(),
  type: zSchema.nativeEnum(WalletTransactionType),
  walletTransactionID: schemes.uuid(),
  zeal_fee: zSchema.number(),
});

export type TWalletTransactionWebhook = zSchema.infer<
  typeof walletTransactionWebhookSchema
>;
